// extracted by mini-css-extract-plugin
export default {"bodyLoader":"style_bodyLoader__Hf5Vg","loader":"style_loader__hnD1P","rotationBack":"style_rotationBack__6y2YW"};